<h1 mat-dialog-title>Incasso aanmaken</h1>
@if (!loadingData() && customers().length > 0) {
  <div mat-dialog-content class="adjusted-dialog-content">
    <p>Selecteer passagiers om toe te voegen aan het incasso bestand.</p>
    <form [formGroup]="customerForm" autocomplete="off" class="checkbox-form">
      @for (customer of customers(); track customer) {
        <mat-checkbox
          class="adjusted-checkbox"
          matInput
          (change)="customerChecked($event, customer)"
          formControlName="{{ customer.id }}"
          [checked]="customer.checked"
        >
          {{ customer.name }}
        </mat-checkbox>
      }
    </form>
  </div>
}
@if (!loadingData() && customers().length === 0) {
  <div mat-dialog-content>Geen passagiers gevonden die een incasso nodig hebben</div>
}
@if (loadingData()) {
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
}
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
  <button
    mat-flat-button
    (click)="createSepa()"
    [disabled]="customers().length === 0 || !checkboxChecker()"
    [class.spinner]="loading()"
  >
    Incasso aanmaken
  </button>
</div>
